<template>
  <div class="container">
    <van-nav-bar
      title="产品手册"
      left-text=""
      left-arrow
      @click-left="onClickLeft"
    />
    <iframe id="mydom" class="mydom" src="https://docs.qq.com/doc/p/34fe82a57196c2f89e5f87e8afd6280446fb6257?dver=2.1.27246538" height="100%" width="100%" scrolling="yes"></iframe>
  </div>
</template>

<script>
  import {NavBar,Icon,Toast,Loading,Button} from 'vant';
  export default {
    data() {
      return {
        isShow: false
      };
    },
    components: {
      [NavBar.name]:NavBar,
      [Icon.name]:Icon,
      [Toast.name]:Toast, 
      [Loading.name]:Loading,
      [Button.name]:Button,
    },
    methods: {
      changePage(url){
        this.$router.push({path: url+".html"})
      },
      onClickLeft() {
        this.$router.go(-1);
      },
    },
    computed:{
    },
    created () {
      
    },
    mounted () {
      setTimeout(()=>{
        this.isShow = true;
        // this.$nextTick(() => {
        //   document.getElementById('mydom').src = 'https://docs.qq.com/doc/p/34fe82a57196c2f89e5f87e8afd6280446fb6257?dver=2.1.27246538'
        // })
      },200)  
    },
    destroyed () {}
  }
</script>

<style lang="less" scoped>
  body,html{width: 100%;height: 100%;background: #F0F4F7}
  .container{
    width: 100%;min-height: 100vh;letter-spacing:0px;background: #F0F4F7;
  }
  .mydom{
    width: 100%;
    min-height: 100vh;
  }
</style>
